import classNames from "classnames";
import React, { Component } from "react";
import "../../../../styles/main.scss";

interface KuikaTitleProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
}

class KuikaTitle extends Component<KuikaTitleProps> {
  render() {
    const { children, className, ...props } = this.props;

    return (
      <span className={classNames("kuika-typography-title", className)} {...props}>
        {children}
      </span>
    );
  }
}

export default KuikaTitle;
